// Explicit .js extension: this module is now reachable from the SERVER build
// (whose nodenext resolution requires it), via the advertisingHome alert
// figures → reportingMoney → here. Every other shared lib already does this.
import type { Currency } from '../types/account.js';

// Currency → display symbol. Exported so the reporting layer (which stores
// native-currency DOLLARS, not cents) can reuse it via src/lib/reportingMoney.ts.
export const CURRENCY_SYMBOL: Record<Currency, string> = {
  AUD: 'A$',
  NZD: 'NZ$',
  USD: 'US$',
  GBP: '£',
  SGD: 'S$',
};

// Money in storage is integer cents. These helpers convert to/from the display
// representation (whole dollars as a number; cents preserved if the user
// inputs them as decimals).
export function centsToDisplay(cents: number | null, currency: Currency | null): string {
  if (cents === null) return '—';
  const symbol = currency ? CURRENCY_SYMBOL[currency] : '$';
  const whole = (cents / 100).toFixed(2);
  return `${symbol}${whole}`;
}

export function centsToInputValue(cents: number | null): string {
  if (cents === null) return '';
  return (cents / 100).toFixed(2);
}

export function inputValueToCents(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === '') return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}
